import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-deep-link';
const CONV_ID = 'conv-1';
const MD_BLOCK_ID = 'blk-dl-md';
const LINK_BLOCK_ID = 'blk-dl-link';
const markdownText = 'I found the inspection you were looking for. Here is a direct link to the record:';
const deepLinkBlock = {
    type: 'deep_link',
    block_id: LINK_BLOCK_ID,
    block_index: 1,
    resource_type: 'inspection',
    resource_id: 'insp-4821',
    label: 'Inspection #4821 — Building A Annual',
    url: '/inspections/4821',
    icon: 'fa-light fa-clipboard-check'
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(deepLinkBlock, 100),
    makeStreamEnd(RESPONSE_ID, 2, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Deep Link Navigation',
    description: 'Streaming markdown followed by an atomic deep_link block pointing to an inspection.',
    conversations: mockConversations,
    userMessage: 'Take me to inspection 4821',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
